import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { of, Observable } from 'rxjs';
export namespace contractVisibleFieldMxProvider {
  export class Visible extends BaseAsyncValue<boolean> {
    getValue(): Observable<any> {
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.RemoveContractFieldEnabled);
      return of(!toggle);
    }
  }
}
